<template>
  <!--
    	作者：zct
    	时间：2021-10-08
    	描述：会员-编辑会员
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--编辑会员-->
      <div class="common-form">编辑用户</div>
      <el-form-item label="会员名称" prop="real_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.real_name" placeholder="请输入会员名称" class="max-w460"></el-input>
      </el-form-item>

      <!-- <el-form-item label="会员logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.logo_image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item> -->
      <el-form-item label="手机号码" prop="mobile" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.mobile" placeholder="请输入会员手机号码" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="新登录密码" >
        <el-input v-model="form.new_password" placeholder="请输入新登录密码,不输入为不改变" type="password" minlength="6" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="性别"  prop="gender" :rules="[{required: true,message: ' '}]">
        <el-radio-group v-model="form.gender">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="所属工会" prop="unit_id" :rules="[{required: true,message: ' '}]">
        <el-select v-model="form.unit_id"  filterable placeholder="请选择" @change="initUnit">
          <el-option
            v-for="item in unit"
            :key="item.unit_id"
            :label="item.unit_name"
            :value="item.unit_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属队伍" prop="unit_group_id" :rules="[{required: true,message: ' '}]" v-if="form.unit_id != ''">
        <el-select v-model="form.unit_group_id"  filterable placeholder="请选择">
          <el-option
            v-for="item in group"
            :key="item.unit_group_id"
            :label="item.unit_group_name"
            :value="item.unit_group_id">
          </el-option>
        </el-select>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import Getpoint from '@/components/map/Getpoint.vue';
  import UserApi from '@/api/user.js';
  import Upload from '@/components/file/Upload';
  import { formatModel } from '@/utils/base.js'
  export default {
    components: {
      /*腾讯地图拾取器*/
      Getpoint,
      Upload
    },
    data() {
      return {
        /*form表单数据*/
        form: {
          user_id:null,
          real_name: '',
          mobile: '',
          gender: 1,
          unit_id: '',
          unit_group_id: '',
          new_password:''
        },
        /*省市区*/
        areaList: [],
        /*查询信息*/
        list: [],
        /*是否上传图片*/
        isupload: false,
        loading: false,
        file_path: '',
        group:[],
        unit:[],
      };
    },
    created() {

      this.form.user_id =this.$route.query.user_id;

      this.getData();
    },

    methods: {
      /*修改*/
      onSubmit() {
        let self = this;
        let form = self.form;

        if (form.mobile.length != 11) {
          self.$message({
            message: '手机号码要11位数！',
            type: 'warning'
          });
          return;
        }
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            UserApi.edituser(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，会员修改成功',
                  type: 'success'
                });
                self.$router.push('/user/user/index');
              }).catch(error => {
                self.loading = false;
              });
          }
        });
      },
      initBureau(e){
        this.bureau.forEach(item=>{
          if(item.bureau_id == e){
            this.position = item.positions
            this.form.position_id = ''
          }
        })
      },
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },
      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },

      /*获取经纬度*/
      getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*获取参数*/
      getData() {
        let self = this;
        UserApi.toEditUser({
            user_id: self.form.user_id
          }, true)
          .then(res => {

            self.form = formatModel(self.form, res.data.model);
            self.unit = res.data.unit;

            self.unit.forEach(item=>{
              if(item.unit_id == self.form.unit_id){
                self.group = item.group
              }
            })

          })
          .catch(error => {

          });

      },

      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null) {
          this.file_path = e[0].file_path;
          this.form.logo_image_id = e[0].file_id;
        }
        this.isupload = false;
      },

      /*选择的地址*/
      choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      initUnit(e){
        this.form.unit_group_id = '';
        this.unit.forEach(item=>{
          if(item.unit_id == e){
            this.group = item.group
          }
        })
        console.log(e)
      },

    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/user/user/edit.vue